module.exports = __webpack_public_path__ + "img/login.50d3d638.svg";